import { AsyncAction } from '../../base-classes/asyncAction';
import { RoadForecastProvider } from '../providers/roadForecastProvider';
import { mapParamsToObject } from '../../utilities/mapParamsToObject';

export const GET_ROAD_FORECAST_BY_LOCATION = new AsyncAction('GET_ROAD_FORECAST_BY_LOCATION');

export function getRoadForecastByLocationAction(...params) {
    let paramsObject = {
        baseUrl: undefined,
        authId: undefined,
        secret: undefined,
        stdParameters: undefined,
        latitude: undefined,
        longitude: undefined,
        speedUnit: undefined, 
        pressureUnit: undefined, 
        temperatureUnit: undefined, 
        distanceUnit: undefined,
        directionUnit: undefined, 
        precipUnit: undefined,
        verbose: false,
        refresh: false
    };
    paramsObject = mapParamsToObject(params, paramsObject);

    return {
        type: GET_ROAD_FORECAST_BY_LOCATION.base,
        payload: getRoadForecastByLocationAsync(paramsObject)
    };
}

async function getRoadForecastByLocationAsync({ baseUrl, authId, secret, stdParameters, latitude, longitude, speedUnit, pressureUnit, temperatureUnit, distanceUnit, directionUnit, precipUnit, verbose, refresh }) {
    const op = new RoadForecastProvider(baseUrl, authId, secret);
    return await op.getRoadForecastByLocation(stdParameters, latitude, longitude, speedUnit, pressureUnit, temperatureUnit, distanceUnit, directionUnit, precipUnit, verbose, refresh);
}
